import * as types from '../constants/ActionTypes'
//import config from '../../config/app.js';
import omit from 'lodash/omit'

export default function therapy_categories(state = {}, action) {
	switch (action.type) {

		case types.SET_THERAPY_CATEGORIES:
		return action.payload.reduce((obj, cat) => {
			obj[cat._id] = cat;
			return obj
		}, {});

		case types.UPDATE_THERAPY_CATEGORY:
		case types.INSERT_THERAPY_CATEGORY:
			return {...state, [action.payload._id]: action.payload};

		case types.DELETE_THERAPY_CATEGORY:
			return omit(state, action.payload)

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/therapy_categories.js